import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Establishments from "./pages/Establishments";
import EstablishmentForm from "./pages/EstablishmentForm";
import EstablishmentDetail from "./pages/EstablishmentDetail";
import Search from "./pages/Search";
import Visits from "./pages/Visits";
import VisitForm from "./pages/VisitForm";
import Brands from "./pages/Brands";
import Analytics from "./pages/Analytics";
import Profile from "./pages/Profile";
import Team from "./pages/Team";
import InviteAccept from "./pages/InviteAccept";
import MfaSetup from "./pages/MfaSetup";
import MfaVerify from "./pages/MfaVerify";
import ChangePassword from "./pages/ChangePassword";

function LoginGate() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/" replace /> : <Login />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginGate />} />
          <Route path="/invite/:token" element={<InviteAccept />} />
          <Route path="/mfa/setup" element={<MfaSetup />} />
          <Route path="/mfa/verify" element={<MfaVerify />} />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/establishments" element={<Establishments />} />
            <Route path="/establishments/new" element={<EstablishmentForm />} />
            <Route path="/establishments/:id" element={<EstablishmentDetail />} />
            <Route path="/establishments/:id/edit" element={<EstablishmentForm />} />
            <Route path="/search" element={<Search />} />
            <Route path="/visits" element={<Visits />} />
            <Route path="/visits/new" element={<VisitForm />} />
            <Route path="/brands" element={<Brands />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/team" element={<Team />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
